import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full md:w-[343px] bg-white rounded-xl border border-ternary flex flex-col divide-y divide-ternary overflow-hidden mb-6" }
const _hoisted_2 = { class: "grid grid-cols-4 divide-x divide-ternary" }
const _hoisted_3 = { class: "h-12 flex items-center justify-center" }
const _hoisted_4 = { class: "h-12 flex items-center justify-center" }
const _hoisted_5 = { class: "h-12 flex items-center justify-center" }
const _hoisted_6 = { class: "h-12 flex items-center justify-center" }
const _hoisted_7 = { class: "grid grid-cols-4 divide-x divide-ternary" }
const _hoisted_8 = { class: "grid grid-cols-4 divide-x divide-ternary" }
const _hoisted_9 = { class: "text-[#dd6c1b] h-12 flex items-center justify-center" }
const _hoisted_10 = { class: "text-[#dd6c1b] h-12 flex items-center justify-center" }
const _hoisted_11 = { class: "text-[#dd6c1b] h-12 flex items-center justify-center" }
const _hoisted_12 = { class: "text-[#dd6c1b] h-12 flex items-center justify-center" }
const _hoisted_13 = {
  key: 0,
  class: "grid grid-col-1 gap-4"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center gap-4" }
const _hoisted_16 = { class: "size-11 shrink-0 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_17 = { class: "font-bold text-base leading-[20px] text-black text-left" }
const _hoisted_18 = {
  key: 0,
  class: "text-base leading-[20px] text-black text-left mt-2"
}

import { elColor } from "@/constants/colors";
import { ref } from "vue";
import { Pillar, TwelvePalace } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import ChevronIcon from "@/components/icons/ChevronIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalPalacesPillarTable',
  props: {
    pillars: {},
    palaces: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const openAccordions = ref<Record<string, boolean>>({});

function toggle(key: string) {
  openAccordions.value[key] = !openAccordions.value[key] ?? true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.hour")), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.day")), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.month")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.year")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass([_unref(elColor)[props.pillars.hour.element], "h-12 flex items-center justify-center"])
        }, _toDisplayString(props.pillars.hour.stem), 3),
        _createElementVNode("div", {
          class: _normalizeClass([_unref(elColor)[props.pillars.day.element], "h-12 flex items-center justify-center"])
        }, _toDisplayString(props.pillars.day.stem), 3),
        _createElementVNode("div", {
          class: _normalizeClass([_unref(elColor)[props.pillars.month.element], "h-12 flex items-center justify-center"])
        }, _toDisplayString(props.pillars.month.stem), 3),
        _createElementVNode("div", {
          class: _normalizeClass([_unref(elColor)[props.pillars.year.element], "h-12 flex items-center justify-center"])
        }, _toDisplayString(props.pillars.year.stem), 3)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(props.pillars.hour.branch), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(props.pillars.day.branch), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(props.pillars.month.branch), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(props.pillars.year.branch), 1)
      ])
    ]),
    (__props.palaces)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.palaces, (palace, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "bg-white rounded-[20px] min-h-[76px] p-4"
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (toggle(key)),
                class: "w-full h-11 flex items-center justify-between"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(palace.hieroglyph), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(palace.label), 1)
                ]),
                _createVNode(ChevronIcon, {
                  class: _normalizeClass({ 'rotate-180': openAccordions.value[key] })
                }, null, 8, ["class"])
              ], 8, _hoisted_14),
              (openAccordions.value[key])
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(palace.description), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})